








import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import BackgroundColorMixin from '@/common/ts/background-color/BackgroundColorMixin';

const FooterLogoProps = Vue.extend({
  props: {
    logoPath: String,
    logoAlt: String,
  },
});

@Component
export default class FooterLogo extends mixins(FooterLogoProps, BackgroundColorMixin) {}
